import React, { useState, useEffect } from "react";
import { Link } from "react-scroll";
import { NavLink } from "react-router-dom";
import logo from "../../images/logo/logo-black.png";
import MobileMenu from "../MobileMenu/MobileMenu";
import RegulatoryNotice from "../RegulatoryNotice/RegulatoryNotice";

const HeaderBuga = (props) => {
  const [mobailActive, setMobailState] = useState(false);
  const [isSticky, setSticky] = useState(false);
  const [headerHeight, setHeaderHeight] = useState(90);
  const headerRef = React.useRef(null);

  const ClickHandler = () => {
    window.scrollTo(10, 0);
  };

  useEffect(() => {
    if (headerRef.current) {
      setHeaderHeight(headerRef.current.offsetHeight || 90);
    }

    const handleScroll = () => {
      if (window.scrollY > 80) {
        setSticky(true);
      } else {
        setSticky(false);
      }
    };

    const handleResize = () => {
      if (headerRef.current) {
        setHeaderHeight(headerRef.current.offsetHeight || 90);
      }
    };

    window.addEventListener("scroll", handleScroll);
    window.addEventListener("resize", handleResize);

    // Clean up
    return () => {
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const SubmitHandler = (e) => {
    e.preventDefault();
  };

  return (
    <div
      id="xb-header-area"
      className="header-area header-style-two header-style-four"
    >
      <div
        className="xb-header-placeholder"
        style={{ minHeight: isSticky ? `${headerHeight}px` : "auto" }}
      >
        <div
          ref={headerRef}
          className={`xb-header stricky  ${
            isSticky ? "stricked-menu stricky-fixed" : ""
          }`}
        >
        <div className="container">
          <div className="header__wrap ul_li_between">
            <div className="header-logo">
              <NavLink onClick={ClickHandler} to="/">
                <img src={logo} style={{ maxWidth: "100px" }} alt="" />
              </NavLink>
            </div>
            <div className="main-menu__wrap ul_li navbar navbar-expand-xl">
              <nav className="main-menu collapse navbar-collapse">
                <ul>
                  <li>
                    <NavLink
                      to="/moneytransfer"
                      spy={true}
                      smooth={true}
                      duration={500}
                      offset={-100}
                      className="menu-item"
                    >
                      Money Transfer
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      to="/about"
                      spy={true}
                      smooth={true}
                      duration={500}
                      offset={-100}
                      className="menu-item"
                    >
                      About Us{" "}
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      to="/help"
                      spy={true}
                      smooth={true}
                      duration={500}
                      offset={-100}
                      className="menu-item"
                    >
                      Help
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      to="/contact"
                      spy={true}
                      smooth={true}
                      duration={500}
                      offset={-100}
                      className="menu-item"
                    >
                      Contact Us
                    </NavLink>
                  </li>

                  {/*                                
                                    <li><NavLink onClick={ClickHandler} to="/contact"><span>Contact</span></NavLink></li> */}
                </ul>
              </nav>
              <div className="xb-header-wrap">
                <div
                  className={`xb-header-menu ${mobailActive ? "active" : ""}`}
                >
                  <div className="xb-header-menu-scroll lenis lenis-smooth">
                    <div
                      className="xb-menu-close xb-hide-xl xb-close"
                      onClick={() => setMobailState(!mobailActive)}
                    ></div>
                    <div className="xb-logo-mobile xb-hide-xl">
                      <NavLink onClick={ClickHandler} to="/" rel="home">
                        <img src={logo} alt="" />
                      </NavLink>
                    </div>
                    <div className="xb-header-mobile-search xb-hide-xl"></div>
                    <nav className="xb-header-nav">
                      <MobileMenu />
                    </nav>
                  </div>
                </div>
                <div className="xb-header-menu-backdrop"></div>
              </div>
            </div>
            <div className="header-bar-mobile side-menu d-xl-none">
              <button
                className="xb-nav-mobile"
                onClick={() => setMobailState(!mobailActive)}
              >
                <i className="far fa-bars"></i>
              </button>
            </div>
            <div className="xb-btn d-none d-md-block ">
              {/* <a
                onClick={ClickHandler}
                href="https://bugamoney.co.uk/app/sign-up"
                className="thm-btn thm-btn--three thm-btn--black"
                target="_blank"
                rel="noopener noreferrer"
              >
                Signup
              </a> */}

              <NavLink
               
                to="/download-buga-app"
                style={{ background: "#ffac07" }}
                className="thm-btn thm-btn--three"
                
                rel="noopener noreferrer"
              >
                Download App
              </NavLink>
              {/* <a
                onClick={ClickHandler}
                href="https://bugamoney.co.uk/app/app-login"
                style={{ background: "#ffac07" }}
                className="thm-btn thm-btn--three thm-btn--black ms-2"
                target="_blank"
                rel="noopener noreferrer"
              >
                Download App
              </a> */}
            </div>
          </div>
        </div>
      </div>
      </div>
      <RegulatoryNotice />
    </div>
  );
};

export default HeaderBuga;
